import React from "react";
import "./LicenseSupportServices.css";

const LicenseSupportServices = () => {
  return (
      <main className='main'>
          <section className='section'>
              <div className="license-support-container container">
                  <h1 className='section-title'>License Support Services</h1>
                  <article className='player-support-intro'>
                      <p>
                          Guidance for B2C operators and B2B critical service suppliers.
                      </p>
                      <p>
                          At Anjouan Gaming, we are committed to providing comprehensive support services to both B2C
                          operators and B2B critical service suppliers. Whether you’re looking to maintain compliance,
                          expand your operations, or apply for new authorizations, our team is here to guide you through
                          every step of the process.
                      </p>
                  </article>

                  <article className='player-support-article'>
                      <h2 className='section-subtitle'>License Support Services</h2>
                      <p>
                          Our dedicated License Support team offers a wide range of services to assist our licensees in
                          navigating the regulatory landscape. We understand the importance of staying compliant and are
                          here to ensure your operations run smoothly.
                      </p>
                  </article>

                  <article className='player-support-article'>
                      <h2 className='section-subtitle'>Guidance for B2C Operators and B2B Critical Service Suppliers</h2>
                      <ul>
                          <li>
                              <strong>Maintaining Compliance:</strong> We provide ongoing guidance to help B2C operators
                              and B2B suppliers keep their existing licensed domains compliant with Anjouan’s regulatory
                              standards. Stay ahead of changes in regulations and ensure your operations remain within
                              the legal framework.
                          </li>
                          <li>
                              <strong>Domain Management:</strong> Need to add or remove domains from your license? Our
                              support team can assist you in managing your licensed domains efficiently. Whether you’re
                              expanding your services or streamlining your operations, we’ll help you make the necessary
                              adjustments to your license.
                          </li>
                          <li>
                              <strong>Managing Aliases:</strong> If you need to add or remove aliases associated with
                              your licensed domains, our team is ready to assist. We ensure that all aliases are
                              correctly registered and compliant with our regulations.
                          </li>
                          <li>
                              <strong>License Verification:</strong> If you need to verify the status of a license, our
                              support team can provide official confirmation. This service is particularly useful for
                              partners, suppliers, and other stakeholders who require assurance of compliance.
                          </li>
                      </ul>
                  </article>

                  <article className='player-support-article'>
                      <h2 className='section-subtitle'>Apply for a B2C or B2B License</h2>
                      <p>
                          Interested in obtaining a B2C or B2B license under Anjouan Gaming? Our support team will guide
                          you through the application process, ensuring that your submission is complete and meets all
                          regulatory requirements. We offer personalized assistance to help you navigate the
                          complexities of the licensing process with ease.
                      </p>
                  </article>

                  <article className='player-support-article'>
                      <h2 className='section-subtitle'>Apply for Key Person Authorization</h2>
                      <p>
                          Key Person Authorizations are essential for ensuring that the individuals in critical
                          positions within your organization meet our stringent standards. Our support team is available
                          to assist with the application process, helping you secure the necessary authorizations for
                          your key personnel.
                      </p>
                  </article>

                  <article className='player-support-article'>
                      <h2 className='section-subtitle'>Get in Touch</h2>
                      <p>
                          For more information or to request assistance with any of our License Support Services, please
                          contact our team. We’re here to help you succeed and ensure that your operations remain
                          compliant, secure, and efficient.
                      </p>
                  </article>
              </div>
          </section>
      </main>
  );
};

export default LicenseSupportServices;